module.exports = __webpack_public_path__ + "media/images/disivo_logo-2576f17dacf4b6c47da8efee3738d981.png";